import { useEffect } from 'react'

import { deleteOperator } from '@/apis/operator'
import OperatorsPageHeader from '@/components/pages/Operator/List/PageHeader'
import OperatorsTable from '@/components/pages/Operator/List/Table'
import { Customer } from '@/types'

import { useOperators } from './Operator.hooks'

const Operators = () => {
  const { getOperatorsLoading, getOperatorsResponse, getOperators } = useOperators()

  const handleDeleteOperator = async (id: Customer['id']) => {
    await deleteOperator({ id })
    getOperators()
  }

  useEffect(() => {
    getOperators()
  }, [getOperators])

  return (
    <>
      <OperatorsPageHeader />
      <OperatorsTable
        {...{
          dataSource: getOperatorsResponse?.items,
          getOperatorsLoading,
        }}
        onDelete={handleDeleteOperator}
      />
    </>
  )
}

Operators.displayName = 'Operators'
export default Operators
